import React from 'react';
import { FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import get from 'lodash/get';

import Avatar from '../../components/Avatar';
import Grid from '../../components/Grid';
import Icon from '../../components/Icon';
import Menu from '../../components/Menu';

import './styles.css';

class RatingsUserList extends React.PureComponent {
  static propTypes = {
    users: PropTypes.arrayOf(PropTypes.object),
    onUserSelected: PropTypes.func,
    selectedUser: PropTypes.object,
  };

  state = {
    users: sortBy(this.props.users, (user) => get(user, 'field_last_name', '').toLowerCase() || null),
  };

  onItemClick = (user) => {
    const { onUserSelected } = this.props;
    if (onUserSelected) {
      onUserSelected(user);
    }
  };

  render() {
    const { users } = this.state;
    return (
      <nav aria-label="Visit feedback Side Menu">
        <Menu as="ul" label="Representatives" vertical className="third" styleName="user-list">
          {users.map((user) => {
            const isSelected = user === this.props.selectedUser;
            const hasRatings = user.ratingsSummary.numRatings > 0;
            return (
              <Menu.Item
                tabIndex={0}
                key={user.uuid}
                data-cy="repvisits-feedback-user-list"
                as="li"
                onClick={() => this.onItemClick(user)}
                disabled={!hasRatings}
              >
                <div
                  className={`menu-link${isSelected ? ' active' : ''}`}
                  styleName="user-list-item"
                >
                  <Grid className="user-list-row-grid">
                    <Grid.Column width={12} verticalAlign="middle" styleName="user-list-data">
                      <Avatar icon="user" image={user.field_profile_picture_file_url} />
                      <span
                        aria-current={isSelected}
                        aria-disabled={!hasRatings}
                        styleName="user-list-name"
                      >
                        {user.name}
                      </span>
                    </Grid.Column>
                    {hasRatings && (
                    <Grid.Column width={4} verticalAlign="middle" textAlign="right" styleName="user-list-rating">
                      <span aria-hidden="true">
                        <FormattedNumber
                          value={user.ratingsSummary.averageRating}
                          minimumFractionDigits={1}
                          maximumFractionDigits={1}
                        />
                      </span>
                      <Icon
                        name="star"
                        aria-label={`${user.ratingsSummary.averageRating} stars`}
                        styleName="user-list-icon"
                        disabled={!isSelected}
                      />
                    </Grid.Column>
                    )}
                  </Grid>
                </div>
              </Menu.Item>
            );
          })}
        </Menu>
      </nav>
    );
  }
}

export default RatingsUserList;
